import { apiClient } from '../../../api/httpClient';

export const getProjectManagementProjects = (params) => (
  apiClient.get('/project-management/projects', { params })
);

export const getProjectManagementMilestones = (params) => (
  apiClient.get('/project-management/milestones', { params })
);

export const getProjectManagementTasks = (params) => (
  apiClient.get('/project-management/tasks', { params })
);
